import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

import BackButton from "../../CustomComponents/Back";
import { ProductInfo as DefaultProductInfo } from "./ProductInfo";
import { Player } from "../../CustomComponents/Player";
import ProductDetails from "./ProductDetails";
import { products } from "../Raw/products";

const getProductDetails = () => {
  return fetch(process.env.REACT_APP_API_URL + "/products")
    .then((res) => res.json())
    .then((res) => {
      return res.reduce((ans, p) => {
        p.categories.forEach(c => c.items.forEach(i => {
          if(i.src) {
            i.src = process.env.REACT_APP_API_URL + i.src;
          }
          if(i.pdfLink) {
            i.pdfLink = process.env.REACT_APP_API_URL + i.pdfLink;
          }
        }))
        ans[p.key] = p;
        return ans;
      }, {});
    });
};

const Product = (props) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [ProductInfo, setProuctInfo] = useState(DefaultProductInfo);
  const [playing, setPlaying] = useState(false);

  const { product } = props.match.params;

  useEffect(() => {
    getProductDetails().then((res) => setProuctInfo(res));
  }, []);

  useLayoutEffect(() => {
    const selectedProduct = products.find((p) => p.page === product);
    if (selectedProduct) {
      setSelectedProduct(selectedProduct);
    }
  }, [product]);

  const goBack = useCallback(() => {
    setPlaying(true);
  }, []);

  const handleEnded = useCallback(() => {
    setPlaying(false);
    props.history.push("/");
  }, [props]);

  if (!selectedProduct) {
    return null;
  }

  return (
    <div className="app">
      <section className="section">
        <div className="custom-homepage-image no-scroll">
          <div className="custom-player-wrapper">
            <Player
              url={selectedProduct.endScene.src}
              playing={playing}
              setPlaying={setPlaying}
              handleEnded={handleEnded}
              frameImg={selectedProduct.productImage}
            />
          </div>
          {!playing ? (
            <div className="product-overlay">
              <BackButton onClick={() => goBack()} />
              <div className="product-name-label">
                <p>{selectedProduct.name}</p>
              </div>
            </div>
          ) : null}
        </div>
        <ProductDetails products={ProductInfo[selectedProduct.id]} />
      </section>
      <img
        className="preload-img"
        alt="Preload"
        loading="lazy"
        src="../../assets/Raw-Water-Transfer/Start-Frame.png"
      />
    </div>
  );
};

export default Product;
